import React from 'react';
import { StoryWrapper } from '../StoryWrapper';
import styles from '../week-reflection.module.css';

export const WorkLifeNetValues = ({ story, action, isPaused, config, storyData }) => {
    let message;
    const workNetValue = storyData.data.work.net;
    const lifeNetValue = storyData.data.life.net;
    if (workNetValue === lifeNetValue) {
        message = `Both Work and Life were net ${workNetValue}.`;
    }
    else {
        if (workNetValue === 'positive') {
            message = `Work was net positive ` + (lifeNetValue === 'negative' ? 'but' : 'and')
                + ` life was net ${lifeNetValue}.`;
        }
        else {
            message = `Life was ${lifeNetValue} ` + (workNetValue === 'negative' ? 'but' : 'and')
                + ` work was net ${workNetValue}.`;
        }
    }

    return (
        <StoryWrapper storyName={storyData.component} action={action} isPaused={isPaused}>
            <h1 className={styles.size2}>
                {message}
            </h1>
            <div className={styles.workLifeCountContainer}>
                <p className={styles.margin0} style={{ width: "3rem" }}>Work</p>
                <div className={styles.flexCenter}>
                    <p className={styles.margin0}>{storyData.data.work.numPleasant}</p>
                    <div className={styles.greenTriangle}></div>
                </div>
                <div className={styles.flexCenter}>
                    <p className={styles.margin0}>
                        {storyData.data.work.numUnpleasant}
                    </p>
                    <div className={styles.redTriangle}></div>
                </div>
            </div>

            <hr className={styles.thinDivider}></hr>

            <div className={styles.workLifeCountContainer}>
                <p className={styles.margin0} style={{ width: "3rem" }}>Life</p>
                <div className={styles.flexCenter}>
                    <p className={styles.margin0}>{storyData.data.life.numPleasant}</p>
                    <div className={styles.greenTriangle}></div>
                </div>
                <div className={styles.flexCenter}>
                    <p className={styles.margin0}>{storyData.data.life.numUnpleasant}</p>
                    <div className={styles.redTriangle}></div>
                </div>
            </div>
        </StoryWrapper>
    );
};